module.exports = __webpack_public_path__ + "static/img/1.06e5aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/1.jpg
// module id = yF/s
// module chunks = 0